import React, { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Divider,
} from "@mui/material";
import useCurrentActionCache from "src/hooks/useCurrentActionCache";
import useForm, { Form } from "src/hooks/useForm";
import { getFLFDevice } from "src/apis/FLF/device.api";
import { getFLFCategory } from "src/apis/FLF/category.api";
import {
  getFLFContextDetailByClause,
  updateFLFContextDevice,
} from "src/apis/FLF/context.api";
import { CACHE_CONTEXT_DEVICE } from "src/constants/actionCache";
import Controls from "src/components/form/controls/Controls";

const initialValue = {
  id: "",
  contextId: "",
  categoryId: "",
  clause: "",
  deviceIds: [],
};

function FLFContextDeviceForm(props) {
  // cache
  const { setCurrentActionCache } = useCurrentActionCache();
  const { listDevice, clause, contextId, setListDevice } = props;

  const [devices, setDevices] = useState([]);
  const [categories, setCategories] = useState([]);

  const { values, setValues, handleInputChange } = useForm(initialValue, false);

  useEffect(() => {
    // * Get list device
    getFLFDevice({}, (result) => {
      if (values.categoryId) {
        setDevices([
          ...result.list.filter(
            (device) => device.category?.id === values.categoryId
          ),
        ]);
      } else {
        setDevices([...result.list]);
      }
    });
    getFLFCategory({}, (result) => {
      setCategories([...result.list]);
    });
  }, [values.categoryId]);

  useEffect(() => {
    const deviceIds = listDevice.map((device) => device.id);
    setValues({
      ...values,
      clause: clause ? clause.toLowerCase() : "",
      contextId,
      deviceIds,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listDevice]);

  const onSubmit = (e) => {
    e.preventDefault();
    updateFLFContextDevice(values, (result) => {
      getFLFContextDetailByClause(contextId, { clause }, (result) => {
        setListDevice([...result.devices]);
      });
      setCurrentActionCache(CACHE_CONTEXT_DEVICE);
    });
  };

  return (
    <Form onSubmit={onSubmit}>
      {values.categoryId !== null ? (
        <Controls.Select
          name="categoryId"
          label="Category"
          value={values.categoryId}
          onChange={handleInputChange}
          options={categories}
          searchable={true}
        />
      ) : null}

      <Accordion
        sx={{
          marginTop: "10px",
          color: "var(--txt-color)",
          backgroundColor: "var(--main-bg)",
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Devices</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            height: "300px",
            overflowY: "auto",
          }}
        >
          <Divider />
          <Controls.MultipleCheckbox
            name="deviceIds"
            label="Devices"
            value={values.deviceIds}
            onChange={handleInputChange}
            options={devices}
          />
        </AccordionDetails>
      </Accordion>

      <Controls.Button
        sx={{ width: "100%", marginTop: "10px" }}
        type="submit"
        text="Submit"
      />
    </Form>
  );
}

export default FLFContextDeviceForm;
